import * as React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import SponsorshipSection from '../components/sponsorship-section/SponsorshipSection';
import NavGradient from '../components/nav-gradient/NavGradient';
import Layout from '../components/layout/Layout';
import SpreadTheWord from '../components/spread-the-word-section/SpreadTheWord';
import Sponsor from '../components/sponsor-section/Sponsor';
import Volunteer from '../components/volunteer-section/Volunteer';
import KeepInTouch from '../components/keep-in-touch-section/KeepInTouch';
import GetInvolvedHeaderSection from '../components/get-involved-header-section/GetInvolvedHeaderSection';
import { GraphicGridDesktop, GraphicGridMobile } from '../lib/shared';
import { icons } from '../style/icons';
import Head from '../components/head/Head';

const GetInvolvedPage = () => {
  const pageQuery = useStaticQuery(graphql`
    query GetInvolvedPageQuery {
      prismicGetInvolved {
        id
        data {
          get_involved_title {
            text
          }
          get_involved_sections {
            section {
              document {
                ... on PrismicGetInvolvedSection {
                  id
                  data {
                    get_involved_section_description {
                      text
                    }
                    get_involved_section_note {
                      text
                    }
                    get_involved_section_title {
                      text
                    }
                    get_involved_section_link {
                      url
                    }
                  }
                }
              }
            }
          }
          sponsorship_section {
            document {
              ... on PrismicSponsorshipSection {
                id
                data {
                  sponsorship_shoutout_heading {
                    text
                  }
                  sponsorships_image {
                    url
                  }
                }
              }
            }
          }
        }
      }
    }
  `);
  const {
    prismicGetInvolved: {
      data: {
        get_involved_title: getInvolvedTitle,
        get_involved_sections: getInvolvedSections,
        sponsorship_section: sponsorshipSection,
      },
    },
  } = pageQuery;

  return (
    <Layout redLine={true}>
      <Head title="Get Involved" />
      <NavGradient />
      <GetInvolvedHeaderSection title={getInvolvedTitle} />
      <SpreadTheWord sectionData={getInvolvedSections[0].section} />
      <Sponsor sectionData={getInvolvedSections[1].section} />
      <Volunteer sectionData={getInvolvedSections[2].section} />
      <KeepInTouch sectionData={getInvolvedSections[3].section} />
      <GraphicGridDesktop
        src={icons.GET_INVOLVED_GRAPHIC_GRID_1_DESKTOP.image}
        alt={icons.GET_INVOLVED_GRAPHIC_GRID_1_DESKTOP.altText}
      />
      <GraphicGridMobile
        src={icons.GET_INVOLVED_GRAPHIC_GRID_1_MOBILE.image}
        alt={icons.GET_INVOLVED_GRAPHIC_GRID_1_MOBILE.altText}
      />
      <SponsorshipSection
        heading={
          sponsorshipSection.document.data.sponsorship_shoutout_heading.text
        }
      />
    </Layout>
  );
};

export default GetInvolvedPage;
